import { render, staticRenderFns } from "./TextButton.vue?vue&type=template&id=f754dffe&scoped=true&lang=pug"
import script from "./TextButton.vue?vue&type=script&lang=ts"
export * from "./TextButton.vue?vue&type=script&lang=ts"
import style0 from "./TextButton.vue?vue&type=style&index=0&id=f754dffe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f754dffe",
  null
  
)

export default component.exports